import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "./App.css";
import Router from "./routes";
import store from "./store/store";
import ThemeProvider from "./theme";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { useEffect, useState } from "react";
import axios from "axios";
import Loader from "./componants/Loader";
import LogInRoutes from "./logInRoutes";
import { logoutChannel } from "./auth/broadcastSetup";
import { base_url } from "./utils";
import { getAccesstoken } from "./helpers/utils";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import "dayjs/locale/ru";

const clearAuthSession = () => {
  sessionStorage.removeItem("token");
  sessionStorage.removeItem("email");
  sessionStorage.removeItem("access");
  sessionStorage.removeItem("accessToken");
  sessionStorage.removeItem("refresh");
  Object.keys(sessionStorage)
    .filter((key) => key.startsWith("digilocker_"))
    .forEach((key) => sessionStorage.removeItem(key));
};

function App() {
  const [state, setstate] = useState("");
  const queryClient = new QueryClient();

  window.history.pushState(null, null, document.URL);
  window.addEventListener("popstate", function () {
    window.history.pushState(null, null, document.URL);
  });

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const urlToken = params.get("token");

    if (urlToken) {
      sessionStorage.setItem("token", "success");
      sessionStorage.setItem("accessToken", urlToken);
      window.location.replace("/dashboard");
      return;
    }

    if (sessionStorage.getItem("token") === "success") {
      const token = getAccesstoken();

      if (!token) {
        clearAuthSession();
        window.location.replace("/login");
        return;
      }

      axios
        .get(`${base_url}/digilocker/getUserDetails`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((response) => {
          setstate(response.data);
        })
        .catch((error) => {
          console.error("Failed to load user details:", error);
          clearAuthSession();
          window.location.replace("/login");
        });
    }
  }, []);

  logoutChannel.onmessage = (event) => {
    if (event.data === "logout") {
      clearAuthSession();
      window.location.replace("/login");
    }
  };

  return (
    <>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <QueryClientProvider client={queryClient}>
          <GoogleOAuthProvider clientId="24660824558-ipphkbm597n20isvqq6doc0b2kebku54.apps.googleusercontent.com">
              <BrowserRouter
                future={{
                  v7_startTransition: true,
                  v7_relativeSplatPath: true,
                }}
              >
                <ThemeProvider>
                  <Provider store={store}>
                    {state?.admin_type === "user" ? (
                      <Router />
                    ) : sessionStorage.getItem("token") !== "success" ? (
                      <LogInRoutes />
                    ) : (
                      <Loader />
                    )}
                  </Provider>
                </ThemeProvider>
              </BrowserRouter>
          </GoogleOAuthProvider>
        </QueryClientProvider>
      </LocalizationProvider>
    </>
  );
}

export default App;
